import React from "react"
import { Dialog, DialogTitle, DialogContent, Box } from "@material-ui/core"
import { InlineTitle } from "./InlineTitle"
import { InlineTitleCloser } from "./InlineTitleCloser"
import { DialogTitleCloser } from "./DialogTitleCloser"
import { ErrorBoundary } from "../ErrorBoundary"
import { disableBackdropClick } from "../../utils"

const CreatorMaster = ({ id = "CreatorMaster", open, subject, title: titleInput, form, isEdit, isInline, onClose }) => {
  const subjectLower = subject && subject.toLowerCase()
  const title = titleInput || (isEdit ? <>Edit {subjectLower}</> : <>Create {subjectLower}</>)

  if (isInline) {
    return (
      <>
        {open && (
          <>
            <InlineTitle>
              {title}
              <InlineTitleCloser onClose={onClose} />
            </InlineTitle>
            <Box py={2} px={2}>
              <ErrorBoundary>{form}</ErrorBoundary>
            </Box>
          </>
        )}
      </>
    )
  }

  return (
    <>
      <Dialog
        id={id}
        open={open}
        onClose={disableBackdropClick(onClose)}
        aria-labelledby="form-dialog-title"
        fullWidth
        maxWidth="md"
      >
        <DialogTitle id="form-dialog-title">
          <ErrorBoundary>
            {title}
            <DialogTitleCloser onClose={onClose} />
          </ErrorBoundary>
        </DialogTitle>
        <DialogContent id={`${id}-content`}>
          <ErrorBoundary>{form}</ErrorBoundary>
        </DialogContent>
      </Dialog>
    </>
  )
}

export { CreatorMaster }
